module.exports = __webpack_public_path__ + "img/gift3.b127542a.png";